import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useRouteError } from "react-router";

import image from "@assets/img/error503.png";
import { useAppTranslation } from "@hooks/useAppTranslation";

import DButton from "@UI/components/Atoms/Button/DButton";
import DPlaceholder from "@UI/components/Organisms/Placeholder/DPlaceholder";

const ErrorBoundaryEmptyState = () => {
  const { t } = useAppTranslation();
  const error = useRouteError();
  const handleRefresh = () => location.reload();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="d-flex-column d-height-100 d-py-32 d-bg-white d-border-radius-16 d-shadow-xs">
      <DPlaceholder
        illustration={image}
        illustrationAlt={t("empty_states.alt.error_503")}
        eyebrow={t("empty_states.oops")}
        title={t("empty_states.service_unavailable")}
        description={t("empty_states.sorry_for_inconvenience")}
        action={<DButton onClick={handleRefresh} label={t("common.refresh")} />}
      />
    </div>
  );
};

export default ErrorBoundaryEmptyState;
